import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "./redirectURL";
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import Select from "react-select";
import { RiDeleteBin5Line } from "react-icons/ri";
// D:\projects\twt_frontend\twt_ui\src\assets\css\inventorymanagement.css
import "../assets/css/inventorymanagement.css";

const MasterData = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnWithDefs, setColumnWithDefs] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [uniqueId , setUniqueId] = useState("")
  const [editRow, setEditRow] = useState(null);
  const [editStatus, setEditStatus] = useState(null);
  const [showShelfDeletePopup, setShowShelfDeletePopup] = useState(false);
  const [selectedShelfRow, setSelectedShelfRow] = useState(null);
  
  const [showSkuDeletePopup, setShowSkuDeletePopup] = useState(false);
  const [selectedSkuRow, setSelectedSkuRow] = useState(null);

  const [currentSkuCode, setCurrentSkuCode] = useState("");
  // const [currentinvoiceDate, setCurrentInvoiceDate] = useState("")
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // "YYYY-MM-DD"
  });

  const [currentUploadedDate, setCurrentUploadedDate] = useState("");
  const [prevDate, setPrevDate] = useState("");
  const [currentDestinationId, setCurrentDestinationId] = useState("");
  const [formData, setFormData] = useState({});

  const [editFormData, setEditFormData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    unit_of_measure: "",
    minimum_order_quantity: "",
  });

  const [skuCode, setSkuCode] = useState({ label: "ALL", value: "" });
  const [storeId, setStoreId] = useState({
    label: "Shelf Life Master Data",
    value: "shelf_life_master",
  });
  const [skuOptions, setSkuOptions] = useState([{ label: "ALL", value: "" }]);
  const [prevStoreId, setPrevStoreId] = useState({ label: "ALL", value: "" });
  const [storeOptions, setStoreOptions] = useState([
    { label: "Shelf Life Master Data", value: "shelf_life_master" },
    { label: "SKU Mapping Data", value: "sku_mapping" },
    { label: "Overall Inventory Data", value: "overall_inventory" },
  ]);

  const shelfLifeCols = [
    {
      headerName: "",
      field: "delete",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell",
      cellRendererFramework: (params) => (
        <div
          style={{
            height: "36px",
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            title="Delete"
            style={{
              height: "30px",
              width: "60px",
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              handleDelete(params.data);
              // setShowDeletePopup(true);
              // setOverlayBlock("show-m")
            }}
          >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
        </div>
      ),
    },
    { headerName: "SKU", field: "sku" },
    { headerName: "Shelf Life Days", field: "shelf_life_days" },
    { headerName: "Fresh Until Days", field: "fresh_until_days" },
    { headerName: "Category", field: "category" },
    { headerName: "Non Invoicable", field: "non_invoicable" },
    { headerName: "Non Invoiceable 1", field: "noninvoiceable_1" },
    { headerName: "Non Invoicable 2", field: "non_invoicable_2" },
    // { headerName: "File Name", field: "file_name", hide:false },
    { headerName: "Sheet Name", field: "sheet_name", hide: true },
    { headerName: "Process", field: "process", hide: true },
    { headerName: "Uploaded Date", field: "uploaded_date" },
  ];

  const skuMappingCols = [
    {
      headerName: "",
      field: "delete",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell",
      cellRendererFramework: (params) => (
        <div
          style={{
            height: "36px",
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            title="Delete"
            style={{
              height: "30px",
              width: "60px",
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              handleDelete(params.data);
              // setShowSkuDeletePopup(true);
              // setOverlayBlock("show-m")
            }}
          >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
        </div>
      ),
    },
    { headerName: "SKU Code", field: "sku_code" },
    { headerName: "SKU", field: "sku" },
    // { headerName: "File Name", field: "file_name", hide: false },
    { headerName: "Sheet Name", field: "sheet_name", hide: true },
    { headerName: "Process", field: "process", hide: true },
    { headerName: "Uploaded Date", field: "uploaded_date", hide: true },
  ];

  const overallInventoryCols = [
    {
      headerName: "Edit",
      field: "is_delete",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell",
      cellRendererFramework: (params) => (
        <div
          style={{
            height: "36px",
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            title="Edit"
            className="mt-2"
            style={{
              height: "30px",
              width: "60px",
              padding: "0 10px",
              border: "1px solid #93385D",
              borderRadius: "4px",
              cursor: "pointer",
              backgroundColor: "#F4EBEF",
              fontSize: "0.8rem",
              color: "#93385D",
            }}
            onClick={() => handleEdit(params.data)} 
          >
            Edit
          </button>
        </div>
      ),
    },
    {
      headerName: "",
      field: "delete",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell",
      cellRendererFramework: (params) => {
        let inactive_status = params.data?.is_active  === 0 ? 0 : 1;
        let shouldDisable = inactive_status === 1 ? true : false;
        return (
          <div
            style={{
              height: "36px",
              padding: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              title={
                shouldDisable ? "Already Active " : "Delete"
              }
              style={{
                height: "30px",
                width: "60px",
                backgroundColor: "transparent",
                border: "none",
                borderRadius: "4px",
                cursor: shouldDisable ? "not-allowed" : "pointer",
                opacity: shouldDisable ? 0.4 : 1,
              }}
              disabled={shouldDisable}
              onClick={() => !shouldDisable && handleDelete(params.data)}
            >
              <RiDeleteBin5Line
                style={{
                  color: shouldDisable ? "transparent" : "red",
                  fontSize: "20px",
                }}
              />
            </button>
          </div>
        );
      },
    },
    { headerName: "Category", field: "category" },
    { headerName: "SKU", field: "sku" },
    { headerName: "Uploaded Date", field: "uploaded_date" },
    {
      headerName: "Status",
      field: "is_delete",
      width : 250,
      valueGetter: (params) => {
        const { is_active} = params.data;
        if (is_active === 0 ) {
          return `Inactive `;
        }
        return "Active"; // covers 0 or undefined
      }
    },
    {
      headerName: "Status Updated Date", field: "status_updated_date",
      valueFormatter: ({ value }) => {
        if (!value) return "Not Updated Yet";
        const d = new Date(value);
        if (isNaN(d)) return "";
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`; // YYYY-MM-DD
      },
    },


    { headerName: "Sheet Name", field: "sheet_name", hide: true },
    { headerName: "Process", field: "process", hide: true },
    { headerName: "Uploaded Date", field: "uploaded_date", hide: true },
  ];

  const handleDelete = (row) => {
    setSelectedRow(row);
    setUniqueId(row._id)
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
  };

  const handleEdit = (row) => {
    setEditRow(row);
    setEditStatus(row?.is_active === 0 ? "Inactive" : "Active");
    setSliderOpen(true);
    setSliderType(4);     
    setSliderCl("slider-25");
    setSliderTitle("Edit Inventory SKU");
    setOverlyBlock("show-m");
  };


  const resetFilters = () => {
    setSkuCode({ label: "ALL", value: "" });
    setStoreId({ label: storeOptions[0]["label"], value: "" });
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const resetFormData = () => {
    setEditFormData({
      sku_code: "",
      sku_name: "",
      sku_category: "",
      unit_of_measure: "",
      minimum_order_quantity: "",
    });
    setDuplicatedEditData({
      sku_code: "",
      sku_name: "",
      sku_category: "",
      unit_of_measure: "",
      minimum_order_quantity: "",
    });
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("");
    setUploadedFileData([]);
  };

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
      ],
    }),
    []
  );

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left",
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center",
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" },
    ],
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  };

  const getResetMasterData = async () => {
    try {
      var params = {
        date: new Date().toISOString().split("T")[0].slice(0, 7),
        datatype: storeOptions[0].value || "ALL",
      };

      const response = await redirectURL.post(
        "inventory/getdpmasterdata",
        params
      );
      if (response.data.status === "success") {
        if (response.data.data) {
        const defaultData = response.data.data.shelf_life_master;
          setRowData(defaultData);
          setStoreId(storeOptions[0]);
          setColumnWithDefs(shelfLifeCols);
          setCurrentInvoiceDate(new Date().toISOString().split("T")[0]);

          setAvailableDates(response.data.data.avaiDates);
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      console.error("Error fetching Historic  data:", error);
      setBasicTitle("Failed to fetch Historic  data");
      setBasicType("error");
      setShow(true);
    }
  };

  const getMasterData = async () => {
    try {
      var params = {
        // date: currentinvoiceDate.slice(0, 7),
        datatype: storeId.value || "ALL",
      };
      const response = await redirectURL.post(
        "inventory/getdpmasterdata",
        params
      );
      if (response.data.status === "success") {
        if (response.data.data) {
          const defaultData = response.data.data.shelf_life_master;
          setRowData(defaultData);
          setAvailableDates(response.data.data.avaiDates);
          if (storeId.value === "shelf_life_master") {
            setColumnWithDefs(shelfLifeCols);
          } else if (storeId.value === "sku_mapping") {
            setColumnWithDefs(skuMappingCols);
          } else if (storeId.value === "overall_inventory") {
            setColumnWithDefs(overallInventoryCols);
          }

        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      console.error("Error fetching Historic  data:", error);
      setBasicTitle("Failed to fetch Historic  data");
      setBasicType("error");
      setShow(true);
    }
  };

  const getSkuMasterDataByFilters2 = async (options) => {
    try {
      var params = {};
      params.invoice_date = currentinvoiceDate ? currentinvoiceDate : "";
      params.destination_store_id = storeId.value ? storeId.value : "";
      params.sku_code = skuCode.value ? skuCode.value : "";

      const response = await redirectURL.post(
        "inventory/getHistoricsalesFilters",
        params
      );
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const defaultData = response.data.data.filter(
            (item) => item.destination_store_id === options[0]["value"]
          );
          setRowData(defaultData);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No Historic  data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching Historic  data:", error);
      setBasicTitle("Failed to fetch Historic  data");
      setBasicType("error");
      setShow(true);
    }
  };

  const getDistinctStoreIdsByDate = async () => {
    try {
      const response = await redirectURL.post("inventory/getDistinctStoreIds", {
        invoice_date: currentinvoiceDate,
      });
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          // setStoreId({label : "Loading...", value : "loading"})
          const distinctOptions = response.data.data;
          // distinctOptions.unshift({label : "ALL", value : ""})
          setStoreId({
            label: distinctOptions[0]["label"],
            value: distinctOptions[0]["value"],
          });
          getSkuMasterDataByFilters2(distinctOptions);
          setStoreOptions(distinctOptions);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No Historic  data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      // console.error("Error fetching Historic  data:", error);
      setBasicTitle("Failed to fetch Historic  data");
      setBasicType("error");
      setShow(true);
    }
  };

  const getDistinctSkuCodes = async () => {
    try {
      var params = {
        invoice_date: currentinvoiceDate,
        destination_store_id: storeId.value,
      };

      const response = await redirectURL.post(
        "inventory/getDistinctSkuCodes",
        params
      );
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const distinctOptions = response.data.data.map((item) => ({
            label: item,
            value: item,
          }));
          distinctOptions.unshift({ label: "ALL", value: "" });

          setSkuCode({ label: "ALL", value: "" });
          setSkuOptions(distinctOptions);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          // setBasicTitle("No Historic  data found");
          // setBasicType("info");
          // setShow(true);
        }
      }
    } catch (error) {
      // console.error("Error fetching Historic  data:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch Historic data");
      setBasicType("error");
      setShow(true);
    }
  };

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getMasterData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };

  useEffect(() => {
    const getData = async () => {
      await getMainData();
      
    };
    getData();
  }, []);

  // useEffect(() => {
  //   const getData = async () => {
  //     if (prevDate !== currentinvoiceDate) {
  //       // setLoadshow("show-m");
  //       // setOverlayBlock("show-m");
  //       await getDistinctStoreIdsByDate()
  //       setLoadshow("show-n");
  //       setOverlayBlock("show-n");
  //     }

  //     }

  //   getData()
  // }, [currentinvoiceDate])

  // useEffect(() => {
  //   const getData = async () => {
  //     if (prevDate !== currentinvoiceDate && prevStoreId.value !== storeId.value) {
  //       // setLoadshow("show-m");
  //       // setOverlayBlock("show-m");
  //       await getDistinctSkuCodes()
  //       setLoadshow("show-n");
  //       setOverlayBlock("show-n");
  //     }

  //     }

  //   getData()
  // }, [currentinvoiceDate , storeId.value])

  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {
      // Check if the element exists
      fileInput.value = ""; // Clears the input if element exists
    }

    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false);
    setSliderOpen(false);
    setCurrentUploadedDate("");
    // resetFormData();
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

  const downloadExcelTemplate = () => {
    // First sheet data - Overall Inventory
    const overallInventoryData = [
      ["Category", "SKU"],
      ["Protein Bar", "DBC"],
      ["Mini PB", "mDBC"],
    ];

    // Second sheet data - SKU Mapping
    const skuMappingData = [
      ["Sku Code", "SKU"],
      ["F1210019", "ACG05"],
      ["F1210020", "QDH24"],
    ];

    const shelflifemasterData = [
      [
        "SKU",
        "Shelf Life days",
        "Fresh until (days)",
        "Category",
        "Non invoicable",
        "Non-invoiceable 1",
        "Non invoicable 2 ",
      ],
      ["55AR", "360", "108", "Dark chocolate", "180", "35", "55"],
    ];

    // Create workbook
    const wb = utils.book_new();

    // Create and add first sheet
    const ws1 = utils.aoa_to_sheet(shelflifemasterData);
    utils.book_append_sheet(wb, ws1, "Shelf Life Master");

    // Create and add second sheet
    const ws2 = utils.aoa_to_sheet(overallInventoryData);
    utils.book_append_sheet(wb, ws2, "Overall Inventory");

    // Create and add third sheet
    const ws3 = utils.aoa_to_sheet(skuMappingData);
    utils.book_append_sheet(wb, ws3, "SKU mapping");

    // Write to file and download
    writeFile(wb, "master_data_template.xlsx");
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   setFile(e.target.value);

  //   const fileName = file.name;
  //   const uploadedDate = new Date().toISOString().split("T")[0]; // format: YYYY-MM-DD

  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     const data = new Uint8Array(event.target.result);
  //     const workbook = XLSX.read(data, { type: "array" });

  //     let parsedData = {
  //       overallInventory: [],
  //       skuMapping: [],
  //       shelfLifeMaster: [],
  //       other: []
  //     };

  //     // Process "Overall Inventory"
  //     if (workbook.SheetNames.includes("Overall Inventory")) {
  //       const overallSheet = workbook.Sheets["Overall Inventory"];
  //       const overallData = XLSX.utils.sheet_to_json(overallSheet, {
  //         raw: false,
  //         dateNF: "yyyy-mm-dd",
  //       });

  //       parsedData.overallInventory = overallData.map(item => ({
  //         category: item.Category || "",
  //         sku: item.SKU || "",
  //         file_name: fileName,
  //         sheet_name: "Overall Inventory",
  //         process: 0,
  //         uploaded_date: uploadedDate
  //       }));
  //     }

  //     // Process "SKU Mapping"
  //     if (workbook.SheetNames.includes("SKU mapping")) {
  //       const mappingSheet = workbook.Sheets["SKU mapping"];
  //       const mappingData = XLSX.utils.sheet_to_json(mappingSheet, {
  //         raw: false,
  //         dateNF: "yyyy-mm-dd",
  //       });

  //       parsedData.skuMapping = mappingData.map(item => ({
  //         sku_code: item["Sku Code"] || "",
  //         sku: item.SKU || "",
  //         file_name: fileName,
  //         sheet_name: "SKU mapping",
  //         process: 0,
  //         uploaded_date: uploadedDate
  //       }));
  //     }

  //     // Process "Shelf Life Master"
  //     if (workbook.SheetNames.includes("Shelf Life Master")) {
  //       const shelfLifeSheet = workbook.Sheets["Shelf Life Master"];
  //       const shelfLifeData = XLSX.utils.sheet_to_json(shelfLifeSheet, {
  //         raw: false,
  //         dateNF: "yyyy-mm-dd",
  //       });

  //       parsedData.shelfLifeMaster = shelfLifeData.map(item => ({
  //         sku: item.SKU || "",
  //         shelf_life_days: item["Shelf Life days"] || "",
  //         fresh_until_days: item["Fresh until (days)"] || "",
  //         category: item.Category || "",
  //         non_invoicable: item["Non invoicable"] || "",
  //         non_invoiceable_1: item["Non-invoiceable 1"] || "",
  //         non_invoicable_2: item["Non invoicable 2"] || "",
  //         file_name: fileName,
  //         sheet_name: "Shelf Life Master",
  //         process: 0,
  //         uploaded_date: uploadedDate
  //       }));
  //     }

  //     // Process other sheets
  //     console.log(workbook.SheetNames, "workbook.SheetNames");

  //     workbook.SheetNames.forEach(sheetName => {
  //       if (!["Overall Inventory", "SKU mapping", "Shelf Life Master"].includes(sheetName)) {
  //         const sheet = workbook.Sheets[sheetName];
  //         const sheetData = XLSX.utils.sheet_to_json(sheet, {
  //           raw: false,
  //           dateNF: "yyyy-mm-dd",
  //         });

  //         const mapping = {
  //           "Destination Store Id": "destination_store_id",
  //           "SKU Code": "sku_code",
  //           "Sale Quantity": "sale_quantity",
  //         };

  //         function toSnakeCase(str) {
  //           return str
  //             .trim()
  //             .replace(/\s+/g, '_')
  //             .replace(/[A-Z]/g, letter => letter.toLowerCase())
  //             .replace(/[^a-z0-9_]/g, '');
  //         }

  //         const processedData = sheetData.map(item => {
  //           const newItem = {};
  //           for (const key in item) {
  //             if (mapping[key]) {
  //               newItem[mapping[key]] = item[key];
  //             } else {
  //               newItem[toSnakeCase(key)] = item[key];
  //             }
  //           }
  //           newItem.file_name = fileName;
  //           newItem.sheet_name = sheetName;
  //           newItem.process = 0;
  //           newItem.uploaded_date = uploadedDate;
  //           return newItem;
  //         });

  //         parsedData.other = [...parsedData.other, ...processedData];
  //       }
  //     });

  //     console.log("Parsed Data:", parsedData);
  //     setUploadedFileData(parsedData);
  //   };

  //   reader.readAsArrayBuffer(file);
  // };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   setFile(e.target.value);

  //   const fileName = file.name;
  //   const uploadedDate = new Date().toISOString().split("T")[0];

  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     const data = new Uint8Array(event.target.result);
  //     const workbook = XLSX.read(data, { type: "array" });

  //     let parsedData = {
  //       overallInventory: [],
  //       skuMapping: [],
  //       shelfLifeMaster: [],
  //       other: [],
  //     };

  //     const normalize = (str) => str.toLowerCase().replace(/\s+/g, "");
  //     const trimValue = (val) => (typeof val === "string" ? val.trim() : val);

  //     function toSnakeCase(str) {
  //       return str
  //         .trim()
  //         .replace(/\s+/g, "_")
  //         .replace(/[A-Z]/g, (letter) => letter.toLowerCase())
  //         .replace(/[^a-z0-9_]/g, "");
  //     }

  //     workbook.SheetNames.forEach((sheetName) => {
  //       const normalizedSheet = normalize(sheetName);
  //       const sheet = workbook.Sheets[sheetName];
  //       const sheetData = XLSX.utils.sheet_to_json(sheet, {
  //         raw: false,
  //         dateNF: "yyyy-mm-dd",
  //       });

  //       const processedData = sheetData.map((item) => {
  //         const newItem = {};

  //         Object.entries(item).forEach(([key, value]) => {
  //           const trimmedKey = key?.toString().trim();
  //           const trimmedValue = trimValue(value);

  //           if (trimmedValue !== null && trimmedValue !== "") {
  //             newItem[toSnakeCase(trimmedKey)] = trimmedValue;
  //           }
  //         });

  //         newItem.file_name = fileName;
  //         newItem.sheet_name = sheetName;
  //         newItem.process = 0;
  //         newItem.uploaded_date = uploadedDate;
  //         return newItem;
  //       });

  //       if (normalizedSheet === "overallinventory") {
  //         parsedData.overallInventory = processedData;
  //       } else if (normalizedSheet === "skumapping") {
  //         parsedData.skuMapping = processedData;
  //       } else if (normalizedSheet === "shelflifemaster") {
  //         parsedData.shelfLifeMaster = processedData;
  //       } else {
  //         parsedData.other = [...parsedData.other, ...processedData];
  //       }
  //     });

  //     console.log("Parsed Data:", parsedData);
  //     setUploadedFileData(parsedData);
  //   };

  //   reader.readAsArrayBuffer(file);
  // };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  setFile(e.target.value);

  const fileName = file.name;
  const uploadedDate = new Date().toISOString().split("T")[0];

  const reader = new FileReader();
  reader.onload = (event) => {
    const data = new Uint8Array(event.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    let parsedData = {
      overallInventory: null,
      skuMapping: null,
      shelfLifeMaster: null,
      other: [],
    };

    const normalize = (str) => str.toLowerCase().replace(/\s+/g, "");
    const trimValue = (val) => (typeof val === "string" ? val.trim() : val);

    function toSnakeCase(str) {
      return str
        .trim()
        .replace(/\s+/g, "_")
        .replace(/[A-Z]/g, (letter) => letter.toLowerCase())
        .replace(/[^a-z0-9_]/g, "");
    }

    workbook.SheetNames.forEach((sheetName) => {
      const normalizedSheet = normalize(sheetName);
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      // Ignore sheets that only have headers (no rows)
      if (sheetData.length === 0) return;

      const processedData = sheetData.map((item) => {
        const newItem = {};
        Object.entries(item).forEach(([key, value]) => {
          const trimmedKey = key?.toString().trim();
          const trimmedValue = trimValue(value);

          if (trimmedValue !== null && trimmedValue !== "") {
            newItem[toSnakeCase(trimmedKey)] = trimmedValue;
          }
        });

        newItem.file_name = fileName;
        newItem.sheet_name = sheetName;
        newItem.process = 0;
        newItem.uploaded_date = uploadedDate;
        return newItem;
      });

      if (processedData.length === 0) return;

      if (normalizedSheet === "overallinventory") {
        parsedData.overallInventory = processedData;
      } else if (normalizedSheet === "skumapping") {
        parsedData.skuMapping = processedData;
      } else if (normalizedSheet === "shelflifemaster") {
        parsedData.shelfLifeMaster = processedData;
      } else {
        parsedData.other = [...parsedData.other, ...processedData];
      }
    });

    // console.log("Parsed Data:", parsedData);
    setUploadedFileData(parsedData);
  };

  reader.readAsArrayBuffer(file);
};


  const getYearMonth = (dateString) => {
    const date = new Date(dateString);
    
    if (isNaN(date)) return { month: null, year: null };

    const month = date.getMonth() + 1; // getMonth() is 0-based
    const year = date.getFullYear();

    return { month, year };
};

  const onClickingFileSubmit = async () => {
    if (
      !uploadedFileData ||
      (
        (!uploadedFileData.overallInventory || uploadedFileData.overallInventory.length === 0) &&
        (!uploadedFileData.skuMapping || uploadedFileData.skuMapping.length === 0) &&
        (!uploadedFileData.shelfLifeMaster || uploadedFileData.shelfLifeMaster.length === 0) &&
        (!uploadedFileData.other || uploadedFileData.other.length === 0)
      )
    ) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file with valid data");
      return;
    }

    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const { month, year } = getYearMonth(currentUploadedDate);

      // ✅ Build params only with non-empty sheets
      const params = {
        date: currentUploadedDate,
        uploaded_year: year,
        uploaded_month: month,
      };

      if (uploadedFileData.overallInventory?.length > 0) {
        params.overallInventory = uploadedFileData.overallInventory;
      }
      if (uploadedFileData.skuMapping?.length > 0) {
        params.skuMapping = uploadedFileData.skuMapping;
      }
      if (uploadedFileData.shelfLifeMaster?.length > 0) {
        params.shelfLifeMaster = uploadedFileData.shelfLifeMaster;
      }
      if (uploadedFileData.other?.length > 0) {
        params.other = uploadedFileData.other;
      }

      const response = await redirectURL.post(
        "inventory/storeMasterData",
        params
      );

      if (response.data.status === "success") {
        await getMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data Uploaded Successfully");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Uploaded Master Data File",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Data Upload Failed");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Uploaded Master Data File",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to upload data";
      setShow(true);
      setBasicType("info");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Uploaded Master Data File",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
    // User Action Triggering Ends Here
    }
  };


  const onClickUploadSkuMasterData = (event) => {
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Upload Masters Data");
    setOverlyBlock("show-m");
  };

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { sku: selectedRow.sku, date:selectedRow.uploaded_date, collection: storeId.value  }; 

    try {
      const response = await redirectURL.post("masters/deleteOverallInventorySku", params);
      if (response.data.status === "success") {
        await getMainData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Deleted Successfully");
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete  Product");
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Product");
    }
  };

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };

  const setfiltersData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getMasterData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };

  const onChangeDataType = async (selectedOption) => {
    setPrevStoreId(storeId);
    setStoreId(selectedOption);
  };

  const allowedDates = ["2025-07-23", "2025-06-10"];
  const allowedMonths = [...new Set(availableDates.map((d) => d.slice(0, 7)))]; // ["2025-07", "2025-06"]

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value; // e.g., "2025-08"
    if (allowedMonths.includes(selectedMonth)) {
      setPrevDate(currentinvoiceDate);
      setCurrentInvoiceDate(selectedMonth + "-01"); // append -01 to keep full date format
    } else {
      alert("Data not available for the seelcted Month");
      e.target.value = currentinvoiceDate.slice(0, 7); // revert to previous
    }
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          ></SweetAlert>
        </div>

        <div
          className="row"
          style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}
        >
          {/* <div className="col-sm-12 p-0">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>Masters Data</h1>
          </div> */}
          <form
            className="col-sm-12 p-0 mb-4"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="col-sm-8 row ">
              {/* <div
                className="col-sm-3 mb-1"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Uploaded Month:
                </label>
                <input
                  type="month"
                  id="invoiceDate"
                  value={currentinvoiceDate.slice(0, 7)}
                  onChange={handleMonthChange}
                  // onChange={(e) => {setPrevDate(currentinvoiceDate); setCurrentInvoiceDate(e.target.value)}}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    document.getElementById("invoiceDate").showPicker?.()
                  }
                />
              </div> */}
              <div
                className="col-sm-3 mb-1"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label
                  htmlFor="storeId"
                  style={{ fontSize: "13px", fontWeight: "400" }}
                >
                  Data Type:
                </label>
                <Select
                  id="storeId"
                  value={storeId}
                  onChange={onChangeDataType}
                  // options={storeOptions.filter(
                  //   (item) => item.label !== "Overall Inventory Data"
                  // )}
                  options={storeOptions}
                  styles={selectStyles}
                />
              </div>

              <div
                className="ml-4 mt-4"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "0px 10px",
                }}
              >
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setfiltersData();
                  }}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Apply
                </button>
                {/* <button
                  onClick={(e) => {
                    e.preventDefault();
                    getResetMasterData();
                  }}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer",
                  }}
                >
                  Reset
                </button> */}
              </div>
            </div>
              <div className="col-sm-4 text-right p-0">

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setSliderOpen(true);
                    setSliderType(3); // new type for Add Form
                    setSliderCl("slider-25");
                    setSliderTitle("Add New SKU Details");
                    setOverlyBlock("show-m");


                    setFormData({});
                  }}
                  className="add-button"
                  style={{ backgroundColor: "#93385D", color: "#fff",padding: "8px 20px",fontSize: "13px"}}
                >
                  + Add
                </button>
                {/* <button
                  onClick={(e) => {
                    e.preventDefault();
                    onClickUploadSkuMasterData();
                  }}
                  className="add-button upload-add-button"
                >
                  <MdOutlineFileUpload
                    style={{ color: "#93385D", fontSize: "18px" }}
                  />
                  {" Upload"}
                </button> */}
              </div>
          </form>
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div
              className="ag-theme-alpine"
              style={{ height: 450, width: "100%" }}
            >
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false,
                }}
              />
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${
          isSliderOpen ? "open" : ""
        } ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {sliderType === 2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={(e) => {
                e.preventDefault();
                onClickingFileSubmit();
              }}
            >
              <div
                className="mb-1"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="d-flex justify-content-end mb-10p">
                  <button
                    id="sample-download-button"
                    onClick={downloadExcelTemplate}
                  >
                    Download Sample Template
                  </button>
                </div>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Date:
                </label>
                <input
                  type="date"
                  id="uploadDate"
                  value={currentUploadedDate}
                  onChange={(e) => {
                    setCurrentUploadedDate(e.target.value);
                  }}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    document.getElementById("uploadDate").showPicker?.()
                  }
                  required
                />
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
                required
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn btn-success"
                  style={{
                    color: "#fff",
                    fontSize: "0.8rem",
                    backgroundColor: "#93385D",
                  }}
                  type="submit"
                >
                  {"Submit"}
                </button>
              </div>
            </form>
          </div>
        )}

        {sliderType === 3 && (
          <div style={{ padding: 15 }}>
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                try {
                  setLoadshow("show-m");
                  setOverlayBlock("show-m");

                  const response = await redirectURL.post(
                    "inventory/storeMasterDataRecord",
                    {
                      datatype: storeId.value,
                      record: formData,
                    }
                  );

                  if (response.data.status === "success") {
                    await getMasterData(); 
                    setShow(true);
                    setBasicType("success");
                    setBasicTitle("Record Added Successfully");
                    setSliderOpen(false);
                    setOverlyBlock("show-n");
                    setFormData({});
                  } else {
                    // fallback in case backend sends custom fail response with 200
                    setShow(true);
                    setBasicType("warning");
                    setBasicTitle(response.data.message || "Failed to add record");
                  }
                } catch (err) {
                  console.error(
                    "Error saving record:",
                    err.response ? err.response.data : err.message
                  );

                  if (err.response?.status === 400) {
                    setShow(true);
                    setBasicType("warning");
                    setBasicTitle(err.response.data.message || "Duplicate record");
                  } else {
                    setShow(true);
                    setBasicType("error");
                    setBasicTitle(
                      err.response?.data?.message || "Error saving record"
                    );
                  }
                } finally {
                  setLoadshow("show-n");
                  setOverlayBlock("show-n");
                }
              }}
            >
              {(() => {
                let fields = [];
                if (storeId.value === "shelf_life_master") fields = shelfLifeCols;
                else if (storeId.value === "sku_mapping") fields = skuMappingCols;
                else if (storeId.value === "overall_inventory") fields = overallInventoryCols;

                return fields
                  .filter(
                    (col) =>
                      !col.hide &&
                      col.field !== "deleted_date" &&
                      col.field !== "Edit" &&
                      col.field !== "delete" &&
                      col.field !== "is_delete" &&
                      col.field !== "uploaded_date" &&
                      col.field !== "non_invoicable_2" &&
                      col.field !== "noninvoiceable_1" &&
                      col.field !== "file_name" &&
                        col.field !== "status_updated_date" // skip auto fields
                  )
                  .map((col) => {
                    const numericOnlyFields = [
                      "shelf_life_days",
                      "fresh_until_days",
                      "non_invoicable",
                      "noninvoiceable_1",
                      "non_invoicable_2",
                    ];

                    const isNumericField = numericOnlyFields.includes(col.field);

                    return (
                      <div key={col.field} className="mb-2">
                        <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                          {col.headerName} { !["noninvoiceable_1", "non_invoicable_2"].includes(col.field) && <span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                            type={isNumericField ? "number" : "text"}
                            step={isNumericField ? "1" : undefined}
                            min={isNumericField ? "0" : undefined}
                            value={formData[col.field] || ""}
                            onChange={(e) => {
                              let value = e.target.value;
                              if (isNumericField) {
                                value = value.replace(/\D/g, "");
                              }
                              setFormData({ ...formData, [col.field]: value });
                            }}
                            className="form-control"
                            style={{ padding: "6px", fontSize: "13px" }}
                            required={
                              !["noninvoiceable_1", "non_invoicable_2"].includes(col.field) // ❌ not required for these
                            }
                          />

                      </div>
                    );
                  });
              })()}

              <div style={{ textAlign: "right", marginTop: "15px" }}>
                <button
                  type="submit"
                  className="btn btn-success"
                  style={{ backgroundColor: "#93385D", fontSize: "0.8rem",border: "none" ,outline: "none"}}
                >
                  ADD
                </button>
              </div>
            </form>
          </div>
        )}

        {/*  SliderType = 4 : Edit Record (Activate / Inactivate)*/}
        {sliderType === 4 && editRow && (
          <div style={{ padding: 15 }}>
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                try {
                  setLoadshow("show-m");
                  setOverlayBlock("show-m");

                  const update_status = editStatus === "Inactive" ? 0 : 1;
                  
                  const payload = {
                    sku: editRow.sku,  
                    date: editRow.uploaded_date, 
                    is_active: update_status, 
                    category: editRow.category,

                  };

                  const url = "masters/toggleOverallInventorySkuStatus";

                  const resp = await redirectURL.post(url, payload);

                  if (resp?.data?.status === "success") {
                    await getMasterData();
                    setShow(true);
                    setBasicType("success");
                    setBasicTitle("Updated successfully");
                    setSliderOpen(false);
                    setOverlyBlock("show-n");
                  } else {
                    setShow(true);
                    setBasicType("warning");
                    setBasicTitle(resp?.data?.message || "Failed to update status");
                  }
                } catch (err) {
                  setShow(true);
                  setBasicType("error");
                  setBasicTitle(
                    err?.response?.data?.message || "Failed to update status"
                  );
                } finally {
                  setLoadshow("show-n");
                  setOverlayBlock("show-n");
                }
              }}
            >

              {/* SKU (read-only) */}
              <div className="mb-2">
                <label style={{ fontSize: "13px", fontWeight: "bold" }}>SKU</label>
                <input className="form-control" value={editRow.sku || ""} readOnly />
              </div>

               {/* Category (edit) */}
             <div className="mb-2">
                <label style={{ fontSize: "13px", fontWeight: "bold" }}>Category</label>
                <input
                  className="form-control"
                  value={editRow.category || ""}
                  onChange={(e) =>
                    setEditRow({ ...editRow, category: e.target.value })
                  }
                />
              </div>

              {/* Status (Active / Inactive) */}
              <div className="mb-2">
                <label style={{ fontSize: "13px", fontWeight: "bold" }}>Status</label>
                <select
                  className="form-control"
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                  style={{ fontSize: "13px" }}
                >
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>


               {/* Uploaded Date */}
              <div className="mb-2">
                <label style={{ fontSize: "13px", fontWeight: "bold" }}>Uploaded Date</label>
                <input className="form-control" value={editRow.uploaded_date || ""} readOnly />
              </div>

              {/* Save */}
              <div style={{ textAlign: "right", marginTop: "15px" }}>
                <button
                  type="submit"
                  className="btn btn-success"
                  style={{ backgroundColor: "#93385D", fontSize: "0.8rem", outline: "none", border: "none"}}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        )}

      </div>
      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to Delete  ${selectedRow ? selectedRow.sku : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
                Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      
    


      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "7px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily: "sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: "1px",
    borderRadius: "5px",
    border: "1px solid #d9d9d9",
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "normal", // <-- make the text not bold
    color: "#333",
    fontSize: "12px", // optional: adjust color
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? "normal" : "normal", // make options also normal if you wish
  }),
};

export default MasterData;
